<template>
  <div class="en-select">
    <div
      class="show-content"
      @click="click"
      :class="{
        'no-data': !inputValue || !inputValue[0] || !inputValue[0].name,
        'is-disabled': disabled,
      }"
    >
      {{
        inputValue && inputValue[0] && inputValue[0].name
          ? inputValue[0].name
          : '请选择'
      }}
    </div>
    <div class="show-list" v-if="showList && !disabled">
      <div class="title">
        <i
          class="close-icon el-icon el-icon-close"
          @click="showList = false"
        ></i>
        {{ fullData.name ? fullData.name : '单选' }}
      </div>
      <div class="show-list-container">
        <div
          class="show-list-item"
          v-for="item in list"
          :key="item.id"
          @click="disabled ? '' : selectDataInfo(item)"
        >
          <div class="show-list-item-container">
            {{ item.name }}
            <div
              class="show-list-item-selected"
              v-if="inputValue[0] && inputValue[0].id === item.id"
            >
              <i class="el-icon el-icon-check"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <en-tips v-model="showTips" :tips="message"> </en-tips>
  </div>
</template>
<script>
import enTips from './../en-tips'

export default {
  name: 'enSelect',
  components: { enTips },
  props: {
    commondata: Object,
    value: {
      default: () => {
        return null
      },
    },
    fullData: {
      type: Object,
      default: () => {
        return {}
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      list: [],
      showList: false,
      showTips: false,
      message: '',
      inputValue: [],
    }
  },
  created() {
    this.fullData._setValue = (nVal) => {
      this.setValue(nVal)
    }
    if (this.fullData.mdValue) {
      this.setValue(this.fullData.mdValue)
    }
    if (Array.isArray(this.fullData.defaults)) {
      this.setDefaultValue()
    }
  },
  watch: {
    value: {
      deep: true,
      handler(nVal) {
        this.setValue(nVal)
      },
    },
    showList(val) {
      if (val) {
        document.getElementsByClassName('business-model')[0].style.overflow =
          'hidden'
      } else {
        document.getElementsByClassName('business-model')[0].style.overflow =
          'auto'
      }
    },
  },
  methods: {
    setValue(nVal) {
      this.inputValue = nVal
    },
    /**
     * @description 获取单选的下拉列表
     * @return {Promise<void>}
     */
    async getListInfo() {
      this.list = []
      const params = await this.commondata.getRelationCondition(this.fullData)
      
      const dict = {
        field: this.fullData.field,
        uuid: this.fullData.uuid,
        objectTypeId: this.fullData.areaObjTypeId,
        ids: Array.isArray(this.fullData.dataArea)
          ? this.fullData.dataArea.map((item) => item.id).join(',')
          : '',
        ...params,
      }

      const urlPath = params
        ? '/bdQuerySingleRangeFiterListShare'
        : '/mdSearchShareRadio'
      let result = await this.$api.post(urlPath, {
        params: JSON.stringify(dict)
      })
      if (result.isSuccess) {
        this.list = params ? result.data : result.data.records
        this.showList = true
        // if (
        //   Array.isArray(this.fullData.dataArea) &&
        //   this.fullData.dataArea.length > 0 &&
        //   parseInt(this.fullData.dataSource, 10) == 2
        // ) {
        //   this.list = this.fullData.dataArea
        // }
        if (params) {
          this.list.map((item) => {
            if (!item.name) {
              item.name = item.code
            }
          })
        }
      } else {
        this.showTips = true
        this.message = result.msg
      }
    },
    /**
     * @description 设置默认选项
     */
    setDefaultValue() {
      const id = JSON.parse(this.fullData.defaults)[0].id
      this.list.map((item) => {
        if (item.id === id) {
          this.selectDataInfo({
            id: item.id,
            name: item.name,
          })
        }
      })
    },
    /**
     * @description 选择完数据信息后，进行回显
     * @param itemData
     */
    selectDataInfo(itemData) {
      const nVal = [
        {
          id: itemData.id,
          name: itemData.name,
        },
      ]
      this.$emit('input', nVal)
      this.setValue(nVal)
      this.$emit('change', this.fullData)
      this.showList = false
    },
    click() {
      if (this.disabled || this.fullData.disabled) {
        return
      }
      this.getListInfo()
    }
  },
}
</script>
<style lang="scss">
.en-select {
  position: relative;
  text-align: right;
  width: 100%;

  .is-disabled {
    background-color: #f9f9f9;
  }

  .show-list {
    position: fixed;
    z-index: 8;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #f7f7f7;

    .title {
      text-align: center;
      color: #ffffff;
      position: relative;
      width: 100%;
      height: 50px;
      line-height: 50px;
      background-color: #31415a;

      .close-icon {
        position: absolute;
        font-size: 32px;
        top: 9px;
        left: 9px;
      }
    }

    .show-list-container {
      height: calc(100% - 50px);
      overflow: auto;
      position: relative;
      z-index: 3;

      .show-list-item {
        background-color: #ffffff;
        padding: 0 20px;
        line-height: 50px;

        .show-list-item-container {
          border-bottom: 1px solid #e8e8e8;
          line-height: 50px;
          text-align: left;
          position: relative;

          .show-list-item-selected {
            position: absolute;
            right: 20px;
            top: 0;
            color: #677ea3;
          }
        }

        &:nth-last-child(1) {
          .show-list-item-container {
            border-bottom: none;
          }
        }
      }
    }
  }
}
</style>
